/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SleepPeriod
 */
export interface SleepPeriod {
    /**
     * 
     * @type {number}
     * @memberof SleepPeriod
     */
    startOffsetSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof SleepPeriod
     */
    endOffsetSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof SleepPeriod
     */
    localStart: string;
    /**
     * 
     * @type {string}
     * @memberof SleepPeriod
     */
    localEnd: string;
}

/**
 * Check if a given object implements the SleepPeriod interface.
 */
export function instanceOfSleepPeriod(value: object): value is SleepPeriod {
    if (!('startOffsetSeconds' in value) || value['startOffsetSeconds'] === undefined) return false;
    if (!('endOffsetSeconds' in value) || value['endOffsetSeconds'] === undefined) return false;
    if (!('localStart' in value) || value['localStart'] === undefined) return false;
    if (!('localEnd' in value) || value['localEnd'] === undefined) return false;
    return true;
}

export function SleepPeriodFromJSON(json: any): SleepPeriod {
    return SleepPeriodFromJSONTyped(json, false);
}

export function SleepPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): SleepPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'startOffsetSeconds': json['start_offset_seconds'],
        'endOffsetSeconds': json['end_offset_seconds'],
        'localStart': json['local_start'],
        'localEnd': json['local_end'],
    };
}

export function SleepPeriodToJSON(json: any): SleepPeriod {
    return SleepPeriodToJSONTyped(json, false);
}

export function SleepPeriodToJSONTyped(value?: SleepPeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start_offset_seconds': value['startOffsetSeconds'],
        'end_offset_seconds': value['endOffsetSeconds'],
        'local_start': value['localStart'],
        'local_end': value['localEnd'],
    };
}

